import { browserSentryOptions } from '@multiplier/lib-shared-sentry/browser';
import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App';
import { Button } from '@/components/ui/button';
import './global.css';

const deployEnv = import.meta.env.VITE_DEPLOY_ENV ?? 'development';

Sentry.init(
  browserSentryOptions({
    dsn: 'https://e685090e63bc0f54802d80f4cce243d0@o4505950121164800.ingest.us.sentry.io/4511275633803264',
    // sendDefaultPii captures cookies, HTTP headers, user IPs, and request bodies.
    // Deliberately enabled for debugging in this tax application — reviewed and approved
    // with data governance. Sentry is only active in staging/production (see `enabled` below).
    sendDefaultPii: true,
    environment: deployEnv,
    enabled: deployEnv === 'production' || deployEnv === 'staging',
    release: import.meta.env.VITE_SENTRY_RELEASE ?? '',
  })
);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in document');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => (
        <div className="flex min-h-screen flex-col items-center justify-center gap-3 p-6 text-center">
          <p className="font-medium text-foreground text-sm">Something went wrong.</p>
          <p className="text-muted-foreground text-sm">The error has been reported.</p>
          <Button onClick={resetError} size="sm" variant="outline">
            Try again
          </Button>
        </div>
      )}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
